import React from 'react';
import { Box, Typography, Container, useTheme } from '@mui/material';
import EngineeringIcon from '@mui/icons-material/Engineering';

const MaintenancePage = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, #e3f2fd 100%)`,
        padding: 3,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            backgroundColor: 'background.paper',
            borderRadius: 4,
            padding: { xs: 4, md: 6 },
            boxShadow: theme.shadows[10],
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <Box
            sx={{
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              borderRadius: '50%',
              padding: 3,
              display: 'inline-flex',
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%': {
                  boxShadow: `0 0 0 0 ${theme.palette.primary.main}80`,
                },
                '70%': {
                  boxShadow: `0 0 0 20px ${theme.palette.primary.main}00`,
                },
                '100%': {
                  boxShadow: `0 0 0 0 ${theme.palette.primary.main}00`,
                },
              },
            }}
          >
            <EngineeringIcon sx={{ fontSize: 64 }} />
          </Box>
          <Typography variant="h4" component="h1" fontWeight="bold" color="text.primary">
            Em Manutenção
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
            Nossa plataforma está passando por atualizações para melhor atendê-lo.
            Tente novamente em breve. Agradecemos a sua compreensão!
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default MaintenancePage;
